import styled from 'styled-components';

export const MainWrapper = styled.div`
  margin-top: 20px;
  & > div {
    display: flex;
    gap: 40px;
    flex-wrap: wrap;
  }
  & > div:first-child {
    margin-bottom: 16px;
  }

  & > div:last-child {
    display: flex;
  }
`;

export const EducationsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 840px;
  gap: 16px;
  column-gap: 40px;
  .education-title-label {
    margin-bottom: 16px;
  }
  .ant-form-item {
    width: 400px;
  }
`;
